// @ts-nocheck
import React, { useState } from 'react';
import SlideoutLayout from './slideout/SlideoutLayout';
import KwPanel from '../common/KwPanel';
import FormStatic from '../common/FormStatic';
import FormGroup from '../common/FormGroup';
import Search from '../settings/users/components/Search';
import { impersonate, impersonationFailed } from '../../services/userService';
import { toast } from 'react-toastify';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { clearConnectedUsers } from '../../reducers/connectedUsersReducer';
import { useAppDispatch } from '../../hooks';

type ImpersonateProps = {
  currentUser: any;
  cancel: () => void;
};

function Impersonate({ currentUser, cancel }: Readonly<ImpersonateProps>) {
  const { t } = useTranslation();
  const [user, setUser] = useState<any>();
  const dispatch = useAppDispatch();

  const handleImpersonate = () => {
    if (!user) {
      toast.error(t('Failed to impersonate user'));
      return;
    }

    impersonate(user.id)
      .then(() => {
        dispatch(clearConnectedUsers());
        window.location.assign('/');
      })
      .catch((e) => {
        console.error(e);
        toast.error(t('Failed to impersonate user'));
      });
  };
  const handleStopImpersonate = () => {
    impersonate()
      .then(() => {
        window.location.reload();
      })
      .catch((e) => {
        impersonationFailed();
      });
  };

  const handleUserSearchChange = (d: any) => {
    if (d && d.length > 0) {
      setUser(d[0]);
    } else {
      setUser(null);
    }
  };

  return (
    <SlideoutLayout
      title={t('Impersonate')}
      cancel={cancel}
      bar={
        <Button
          className="btn btn-primary"
          isDisabled={!user}
          onClick={handleImpersonate}
          text={t('Impersonate')}
        />
      }
    >
      <KwPanel className="mb-4">
        <FormGroup label={t('User to impersonate')}>
          <Search onChange={handleUserSearchChange} />
        </FormGroup>
      </KwPanel>
      {currentUser?.isImpersonating && (
        <KwPanel className="mb-4">
          <header>
            <h2>{t('You are currently impersonating..')}</h2>
            <Button
              className="btn btn-default"
              onClick={handleStopImpersonate}
              text={t('Stop')}
            />
          </header>
          <FormStatic label={t('User')}>{currentUser?.username}</FormStatic>
        </KwPanel>
      )}
    </SlideoutLayout>
  );
}

export default Impersonate;
